export const selectSessionData = ({ session: { data } }) => ({ ...data });
export const selectIsRefreshing = ({ session }) => session.refreshingToken;
export const sessionHydrated = ({ session: { _persist } }) =>
  _persist.rehydrated;
export const selectTimeoutModal = ({ session }) => session.timeoutModal;
